import apiClient from './apiClient';

export async function fetchReports() {
  const { data } = await apiClient.get('/reports');
  return data;
}

export async function fetchReport(reportId) {
  const { data } = await apiClient.get(`/reports/${reportId}`);
  return data;
}

export async function requestReport(payload) {
  const { data } = await apiClient.post('/reports', payload);
  return data;
}

export async function deleteReport(reportId) {
  await apiClient.delete(`/reports/${reportId}`);
}

export async function downloadReportFile(reportId, format) {
  const response = await apiClient.get(`/reports/${reportId}/export.${format}`, { responseType: 'blob' });
  const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename=\"?([^\";]+)\"?/i);
  anchor.download = match?.[1] || `cyberguard-report-${reportId}.${format}`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
